import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import {
  AddressModelKeys,
  ASSOCIATION_KEYS_LOOKUP,
  AssociationKeys,
  ASSOCIATIONS_SEARCH_KEYS_CONFIG,
  ChangeLogsHistoryType,
  ChangeLogsType,
} from '@ag-common-lib/public-api';
import {
  hasLog,
  isEmptyObjectLog,
  isLogArray,
  normalizeLog,
} from 'ag-common-svc/lib/components/changes-history-grid/utils/normalize-log';

@Component({
  selector: 'ag-shr-agent-associations-info-log-details',
  templateUrl: './agent-associations-info-log-details.component.html',
  styleUrls: ['./agent-associations-info-log-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentAssociationsInfoLogDetailsComponent {
  @Input() oldData: any = null;
  @Input() changeLogs: Delta;

  protected readonly associationsSearchKeysConfig = ASSOCIATIONS_SEARCH_KEYS_CONFIG;
  protected readonly ChangeLogsType = ChangeLogsType;
  protected readonly AssociationKeys = AssociationKeys;
  protected readonly isLogArray = isLogArray;
  protected readonly isEmptyObjectLog = isEmptyObjectLog;
  protected readonly hasLog = hasLog;
  protected readonly normalizeLog = normalizeLog;
  protected readonly associationKeysLookup = ASSOCIATION_KEYS_LOOKUP;
  protected readonly ChangeLogsHistoryType = ChangeLogsHistoryType;
  protected readonly AddressModelKeys = AddressModelKeys;
}
